import { Pagination as MuiPagination, PaginationProps } from "@mui/material";

type Props = PaginationProps;

export const Pagination = ({ ...props }: Props) => {
  return <MuiPagination {...props} />;
};
